import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=6f15d1aa&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"
import style0 from "./Dropdown.scss?vue&type=style&index=0&id=6f15d1aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15d1aa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotDropdownGroupsContent: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/DropdownGroup/DropdownGroupsContent.vue').default,HotDropdownNormalContent: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Molecules/DropdownNormalContent/DropdownNormalContent.vue').default})
